/**
 * useNutrientColors — the one-colour-per-nutrient map (`NutrientColors` in
 * src/theme/tokens.ts) for the active colour scheme (mirror of mobile
 * hooks/use-nutrient-colors.ts). Every surface that colours a nutrient reads
 * it from here (or from the matching `n-*` Tailwind colour) so sat fat is the
 * same brown on the meal card, the trend chart, the rings and the summary.
 */

import { NutrientColors, type NutrientColorKey } from '@/theme/tokens';
import { useColorScheme } from '@/hooks/use-color-scheme';
import { withAlpha } from '@/theme/color';

export type { NutrientColorKey };

export function useNutrientColors() {
  const scheme = useColorScheme() === 'dark' ? 'dark' : 'light';
  const colors = NutrientColors[scheme];
  /** Soft background for a nutrient chip/icon well. */
  const tint = (key: NutrientColorKey, alpha = scheme === 'dark' ? 0.18 : 0.12) => withAlpha(colors[key], alpha);
  return { ...colors, colors, tint, isDark: scheme === 'dark' };
}
